import { useState, useEffect } from 'react';

export function useCSSVariable(watch: HTMLElement, target: HTMLElement, name: string) {
    const [value, setValue] = useState(() =>
        getComputedStyle(target).getPropertyValue(name).trim()
    );

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const newValue = getComputedStyle(target).getPropertyValue(name).trim();
            setValue(newValue);
        });

        const observerConfig =
            watch.tagName === 'HEAD'
                ? { childList: true, subtree: true }
                : { attributes: true, subtree: false };
        observer.observe(watch, observerConfig);

        return () => observer.disconnect();
    }, [watch, target, name]);

    return value;
}
